var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDCoolingInjectionCircuit = function SvgDCoolingInjectionCircuit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 420,
    width: 100,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 424.99 100 424.99 100 426.99 0 427.02 0 424.99",
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 423 100 422.97 100 422 0 422 0 423",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 428.99,
    width: 99.99,
    height: 1,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "52 422 49 422 49 423 43 423 43 422 40 422 40 66.53 52 66.5 52 422",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 66.5,
    width: 1,
    height: 356.49,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 66.5,
    width: 2,
    height: 358.49,
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50 422 49.01 422 49 66.5 49.99 66.53 50 422",
    fill: "#787878"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.01,
    y: 382,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.04,
    y: 395,
    width: 10.01,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "38.87 382.5 53.15 382.51 46 394.99 38.87 382.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.73,383h12.56s-6.29,10.98-6.29,10.98l-6.27-10.98M38.01,382l7.99,14,8.02-13.99h-16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "38.86 409.5 46 397.01 53.15 409.5 38.86 409.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,398.01l6.29,10.99h-12.56l6.27-10.99M46,396l-8,14h16.01l-8.02-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 396,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,386c5.52,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M25,385c-6.08,0-11,4.92-11,11s4.93,11,11,11,11-4.92,11-11-4.93-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.36,392.65l1.64,4.36,1.64-4.36h1.28v5.69h-.98v-1.88l.1-2.51-1.68,4.38h-.71l-1.68-4.38.1,2.5v1.88h-.98v-5.69h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74,439.5c-7.44,0-13.5-6.06-13.5-13.5s6.06-13.5,13.5-13.5,13.5,6.06,13.5,13.5-6.06,13.5-13.5,13.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,413c7.17,0,13,5.83,13,13s-5.83,13-13,13-13-5.83-13-13,5.83-13,13-13M74,412c-7.73,0-14,6.27-14,14s6.27,14,14,14,14-6.27,14-14-6.27-14-14-14h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.71,426.5c.13,0,.26-.05.36-.15l13.15-13.5c.19-.2.19-.51,0-.71-.2-.19-.52-.19-.71,0l-13.15,13.5c-.19.2-.19.51,0,.71.1.09.22.14.35.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86,440c.13,0,.25-.05.35-.14.2-.19.2-.51,0-.71l-13.15-13.5c-.19-.2-.51-.2-.71,0-.2.19-.2.51,0,.71l13.15,13.5c.1.1.23.15.36.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46,363.5c-7.44,0-13.5-6.06-13.5-13.5s6.06-13.5,13.5-13.5,13.5,6.06,13.5,13.5-6.06,13.5-13.5,13.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,337c7.17,0,13,5.83,13,13s-5.83,13-13,13-13-5.83-13-13,5.83-13,13-13M46,336c-7.73,0-14,6.27-14,14s6.27,14,14,14,14-6.27,14-14-6.27-14-14-14h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,336.71c0,.13.05.26.15.36l13.5,13.15c.2.19.51.19.71,0,.19-.2.19-.52,0-.71l-13.5-13.15c-.2-.19-.51-.19-.71,0-.09.1-.14.22-.14.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,349.86c0,.13.05.25.14.35.19.2.51.2.71,0l13.5-13.15c.2-.19.2-.51,0-.71-.19-.2-.51-.2-.71,0l-13.5,13.15c-.1.1-.15.23-.15.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "49.99 368 87 368 87 380 49.99 380 49.99 378 49 377 49 370.97 49.99 370 49.99 368",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 377,
    width: 38,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 370.01,
    width: 38,
    height: 0.97,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.97,
    y: 373.01,
    width: 6,
    height: 2,
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86,375.01h-9.33v-2h9.33v2ZM65.41,375.01h-9.33v-2h9.33v2Z",
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.97,
    y: 373.01,
    width: 6,
    height: 2,
    fill: "#437fa3"
  }))))));
};
export default SvgDCoolingInjectionCircuit;